import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'vs-app-scaffold',
  templateUrl: './app-scaffold.component.html',
  standalone: false,
})
export class AppScaffoldComponent {
  @HostBinding('class') styles = 'flex flex-col w-full h-full';
}
